<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          PROFILE
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Detail Profile
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="search" @click="getData()" title="refresh">
              refresh
            </v-icon>
          </v-flex>
        </v-card-title>
        <v-flex xs12 class="pa-7">
          <v-layout row wrap>
            <table width="100%">
              <tr>
                <td>Profile Name</td>
                <td>:</td>
                <td class="grey--text">{{ items.desc }}</td>
              </tr>
              <tr>
                <td>Position</td>
                <td>:</td>
                <td class="grey--text">
                  {{ items.position ? items.position.position : '-' }}
                </td>
              </tr>
              <tr>
                <td>Brand</td>
                <td>:</td>
                <td
                  class="grey--text"
                  :style="!items.mapping ? 'white-space: pre-line;' : ''"
                  v-if="items.mapping"
                >
                  <span v-if="items.mapping.brand">
                    {{ items.mapping.brand ? items.mapping.brand.name : '-' }}
                  </span>
                  <v-chip
                    v-else
                    v-for="(item, index) in items.mappingBrand"
                    :key="index"
                    class="mr-2 mb-2"
                    small
                  >
                    {{ item.brand.name }}
                  </v-chip>
                </td>
              </tr>
              <tr>
                <td>Division</td>
                <td>:</td>
                <td class="grey--text">
                  {{ items.mapping.divisi ? items.mapping.divisi.name : '-' }}
                </td>
              </tr>
              <tr>
                <td>House</td>
                <td>:</td>
                <td class="grey--text">
                  {{ items.mapping.house ? items.mapping.house.name : '-' }}
                </td>
              </tr>
              <tr>
                <td>Department</td>
                <td>:</td>
                <td class="grey--text">
                  {{
                    items.mapping.department
                      ? items.mapping.department.name
                      : '-'
                  }}
                </td>
              </tr>
              <tr>
                <td>Entity</td>
                <td>:</td>
                <td class="grey--text">
                  {{ items.mapping.entity ? items.mapping.entity.name : '-' }}
                </td>
              </tr>
              <tr>
                <td>Permission</td>
                <td>:</td>
                <td class="grey--text" style="white-space: pre-line;">
                  <v-chip
                    v-for="(item, index) in items.permission"
                    :key="index"
                    class="mr-2 mb-2"
                  >
                    {{ item.name }}
                  </v-chip>
                </td>
              </tr>
              <tr>
                <td>Group</td>
                <td>:</td>
                <td
                  class="grey--text"
                  style="white-space: pre-line;"
                  v-if="items.groups"
                >
                  <v-chip
                    v-for="(item, index) in items.groups"
                    :key="index"
                    class="mr-2 mb-2"
                    small
                  >
                    {{ item.name }}
                  </v-chip>
                </td>
              </tr>
              <tr>
                <td>Division View</td>
                <td>:</td>
                <td
                  class="grey--text"
                  style="white-space: pre-line;"
                  v-if="items.divisiViews"
                >
                  <v-chip
                    v-for="(item, index) in items.divisiViews"
                    :key="index"
                    class="mr-2 mb-2"
                    small
                  >
                    {{ item.name }}
                  </v-chip>
                </td>
              </tr>
              <tr v-if="loaded">
                <td>
                  <form-channel
                    :account.sync="items.accounts"
                    :channel.sync="items.channels"
                    :isFormProfile="true"
                    :isDetail="true"
                  />
                </td>
              </tr>
            </table>
          </v-layout>
        </v-flex>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-flex xs2 right class="mr-4">
            <v-btn
              id="btn-back"
              dark
              rounded
              color="red"
              block
              :to="{ name: 'profile' }"
            >
              Back
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';
import formChannel from '@/components/formChannel';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog,
    'form-channel': formChannel
  },
  props: ['id'],
  data() {
    return {
      items: {},
      loading: true,
      progressDialogLoading: true,
      search: '',
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Profile List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'Profile Detail',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      loaded: false
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.progressDialogLoading = false;
    //   this.loading = false;
    // }, 3000);
    this.getData();
  },
  methods: {
    getData() {
      this.loaded = false;
      this.progressDialogLoading = true;
      this.loading = false;
      const id = this.id;
      return this.$store.dispatch('profile/detail', { id }).then(data => {
        this.progressDialogLoading = false;
        this.loading = false;
        if (data.code === 200) {
          this.items = data.data;
          this.items.accounts = this.items.accounts.map(item => {
            return {
              account: {
                ...item
              },
              id: item.id,
              name: item.name
            };
          });
          this.loaded = true;
        } else {
          Swal.fire('Failed!', data.response.data.message.text_en, 'error');
        }
      });
    }
  }
};
</script>
